export const allCountryCodes = [
    'ar',
    'be',
    'br',
    'ca',
    'co',
    'de',
    'dk',
    'es',
    'fi',
    'fr',
    'gb',
    'ie',
    'it',
    'mx',
    'my',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
] as const;
export type CountryCode = (typeof allCountryCodes)[number];
export const isCountryCode = (value?: string): value is CountryCode => {
    return !!value && allCountryCodes.some(item => item === value.toLowerCase());
};
